const ApplicationShowcase = () => {
  const applications = [
    {
      title: 'Luxury Eco-Tourism',
      description: 'Transform scenic spots into premium glamping destinations with zero ecological impact.',
      image: '/images/ai-luxury-glamping-resort-in-pristine-mount-950b56.webp'
    },
    {
      title: 'Residential Expansion',
      description: 'Add a futuristic backyard office or a private guest suite to your home in just 24 hours.',
      image: '/images/ai-modern-futuristic-backyard-office-pod-in-3b9190.webp'
    },
    {
      title: 'Mobile Commercial Spaces',
      description: 'Eye-catching pop-up shops, cafes, and creative studios that move with your business.',
      image: '/images/ai-striking-modern-pop-up-cafe-and-retail-s-e790c8.webp'
    },
    {
      title: 'Remote Living Pods',
      description: 'Engineered with superior Heat Insulation for comfortable living in extreme climates.',
      image: '/images/ai-advanced-insulated-living-pod-in-extreme-63fe63.webp'
    }
  ];

  return (
    <section id="applications" className="py-24 bg-gradient-to-b from-[#0A0A0A] via-[#0D1117] to-[#000000]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Hero Title */}
        <div className="text-center mb-20">
          <h2 className="text-5xl font-bold text-white mb-4">
            Versatile Solutions for Modern Living & Business
          </h2>
          <div className="w-24 h-1 bg-cyan-500 mx-auto"></div>
        </div>

        {/* Applications Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {applications.map((app, index) => (
            <div
              key={index}
              className="group relative bg-white/5 backdrop-blur-sm rounded-2xl overflow-hidden border border-white/10 hover:border-cyan-500/50 transition-all duration-500 hover:shadow-[0_0_40px_rgba(6,182,212,0.3)]"
            >
              <div className="relative w-full h-64">
                <img
                  src={app.image}
                  alt={app.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent"></div>
              </div>
              <div className="p-8">
                <h3 className="text-2xl font-bold text-white mb-4 group-hover:text-cyan-400 transition-colors">
                  {app.title}
                </h3>
                <p className="text-gray-400 leading-relaxed text-base">
                  {app.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ApplicationShowcase;
